/**
 * Law25Banner
 *
 * Sticky privacy notice shown on any Org page that surfaces rented
 * Creator data (UPDATE.md §9.2). The exact message varies by surface
 * (Audience vs. Insights vs. Assignments), so the parent passes the
 * body via `message`; we own the wrapper, icon, and tone so the look
 * stays consistent everywhere.
 */

import React from 'react';
import { node, string } from 'prop-types';
import classNames from 'classnames';

import css from './Law25Banner.module.css';

const Law25Banner = props => {
  const { className, message } = props;
  return (
    <div className={classNames(css.root, className)} role="note">
      <span className={css.text}>{message}</span>
    </div>
  );
};

Law25Banner.defaultProps = { className: null };

Law25Banner.propTypes = {
  className: string,
  message: node.isRequired,
};

export default Law25Banner;
